// Safari compatibility check and polyfills
export const checkSafariCompatibility = () => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    console.log('Browser detection:', {
        isSafari,
        isIOS,
        userAgent: navigator.userAgent,
        vendor: navigator.vendor,
        platform: navigator.platform
    });
    
    // Check for required features
    const features = {
        serviceWorker: 'serviceWorker' in navigator,
        promise: typeof Promise !== 'undefined',
        fetch: typeof fetch !== 'undefined',
        localStorage: typeof localStorage !== 'undefined',
        sessionStorage: typeof sessionStorage !== 'undefined',
        indexedDB: 'indexedDB' in window,
        customElements: 'customElements' in window,
        webkitURL: 'webkitURL' in window
    };
    
    console.log('Feature detection:', features);
    
    // iOS specific checks
    if (isIOS) {
        // Check iOS version
        const match = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
        if (match) {
            const version = parseInt(match[1], 10);
            console.log('iOS version:', version);
            
            if (version < 13) {
                console.warn('iOS version is less than 13, some features may not work');
            }
        }
        
        // Check for Safari settings that might block functionality
        if (!features.localStorage) {
            console.error('localStorage is not available - might be disabled in Safari settings');
        }
    }
    
    return { isSafari, isIOS, features };
};

// Add polyfills for older Safari versions
export const addSafariPolyfills = () => {
    // Polyfill for Object.entries if needed
    if (!Object.entries) {
        Object.entries = function(obj) {
            var ownProps = Object.keys(obj),
                i = ownProps.length,
                resArray = new Array(i);
            while (i--)
                resArray[i] = [ownProps[i], obj[ownProps[i]]];
            return resArray;
        };
    }
    
    // Polyfill for Array.from if needed
    if (!Array.from) {
        Array.from = function(arrayLike) {
            return [].slice.call(arrayLike);
        };
    }
};